import { cn } from "@/lib/utils";

type Props = {
  content: string;
};

export function DiffView({ content }: Props) {
  const lines = content.split("\n");

  return (
    <div className="text-xs font-mono overflow-x-auto">
      {lines.map((line, i) => {
        const isAdd = line.startsWith("+") && !line.startsWith("+++");
        const isRemove = line.startsWith("-") && !line.startsWith("---");
        const isHeader = line.startsWith("@@");

        return (
          <div
            key={i}
            className={cn(
              "px-2 py-0.5 whitespace-pre",
              isAdd && "bg-green-900/40 text-green-300",
              isRemove && "bg-red-900/40 text-red-300",
              isHeader && "text-zinc-500 italic",
              !isAdd && !isRemove && !isHeader && "text-zinc-400"
            )}
          >
            {line}
          </div>
        );
      })}
    </div>
  );
}
